import moment from "moment/moment";
import EnrollmentProgressStepper from "../EnrollmentProgressStepper/EnrollmentProgressStepper";
import React, { useTransition } from "react";
import { apiRequest } from "../Utils/APIUtils";
import { useNavigate } from "react-router-dom";
import './ManageEnrolments.css';
import { useTranslation } from "react-i18next";

//Displays a nice tile for the enrolment
// buttons to delete or duplicate the enrolment are optionally shown based on whether or not the functions are provided which set the enrolment to delete or duplicate
const EnrolmentTile = ({ enrolment, setEnrolmentToDelete, setEnrolmentToDuplicate }) => {
    const { t } = useTranslation();

    const beneName = enrolment.beneficiary.firstName && enrolment.beneficiary.lastName ? `${enrolment.beneficiary.firstName} ${enrolment.beneficiary.lastName}` : t('Beneficiary name unknown');
    const docusignStatus = enrolment.docusign ? enrolment.docusign.status : 'PRE_FEATURE';


    return (
        <div className={'enrolment-tile'} key={enrolment._id}>
            <div className={'beneficiary-name'}>
                <span>{beneName}</span>
                {enrolment.application && enrolment.application.childApplicationIds &&
                    <span
                        data-tooltip-content={t('Family Enrolment')}
                        data-tooltip-id={'tooltip'}
                    >
                        <span className="material-symbols-outlined">
                            diversity_3
                        </span>
                        +{enrolment.application.childApplicationIds.length}
                    </span>
                }
            </div>
            <div className={'date-updated'}>
                {moment(enrolment.dateCreated).format("MMMM Do YYYY [at] h:mm a")}
            </div>

            <div className={'action-buttons'}>
                <span className={'edit-button'}>
                    <a href={'/enrolment/' + enrolment._id}>
                        {enrolment.state === 'pre-docusign' &&
                            <span className="material-symbols-outlined"
                                data-tooltip-content={'View/Edit Enrolment'}
                                data-tooltip-id={'tooltip'}
                                data-tooltip-place="bottom"
                            >
                                edit_square
                            </span>
                        }
                        {enrolment.state !== 'pre-docusign' &&
                            <span className="material-symbols-outlined"
                                data-tooltip-content={'View Enrolment'}
                                data-tooltip-id={'tooltip'}
                                data-tooltip-place="bottom"
                            >
                                pageview
                            </span>
                        }
                    </a>
                </span>
                {enrolment.state === 'pre-docusign' && setEnrolmentToDelete &&
                    <span className={'delete-button'}>
                        <span
                            onClick={() => setEnrolmentToDelete(enrolment._id)}
                            className={'clickable material-symbols-outlined'}
                            data-tooltip-content={'Delete Enrolment'}
                            data-tooltip-id={'tooltip'}
                            data-tooltip-place="bottom"
                        >
                            delete
                        </span>
                    </span>
                }

                {setEnrolmentToDuplicate &&
                    <span
                        onClick={() => setEnrolmentToDuplicate(enrolment._id)}
                        className={'clickable material-symbols-outlined'}
                        data-tooltip-content={'Duplicate Enrolment'}
                        data-tooltip-id={'tooltip'}
                        data-tooltip-place="bottom"
                    >
                        content_copy
                    </span>
                }
            </div>

            <EnrollmentProgressStepper hideLabels={false}
                state={{
                    ...enrolment,
                    enrollment: {
                        state: enrolment.state,
                        docusign: {
                            status: docusignStatus
                        }
                    }
                }}

            />
        </div>
    )
}

export default EnrolmentTile;